import React from 'react';
import { Container, Card, CustomLink, Shape, Heading } from '@teko/ds-desktop';
import { MenuItem } from '@teko/discovery';
import { BlockHeader, MenuPanel } from '@teko/teko-ecommerce';
import { convertMegaMenuItem } from 'helpers';
import { useIdentifiedPage } from 'hooks';
import { t } from 'i18n';
import Head from 'next/head';

export const Categories: React.FunctionComponent<{
  serverCategoryList: MenuItem[];
}> = ({ serverCategoryList }) => {
  const categoryList = serverCategoryList || [];
  useIdentifiedPage('category');

  if (!categoryList.length) return null;

  return (
    <>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <Container>
        <Card marginTop="s40" marginBottom="s40" padding="s8">
          <BlockHeader title={t('Danh mục sản phẩm')} />
          {categoryList.map((item, index) => {
            const convertedMenu = convertMegaMenuItem(item);
            return (
              <div key={item.id}>
                <Shape paddingLeft="s16">
                  <CustomLink {...convertedMenu.link}>
                    <Heading level={4}>{convertedMenu.name}</Heading>
                  </CustomLink>
                </Shape>
                <MenuPanel
                  key={index}
                  menu={[convertedMenu]}
                  activeMenu={convertedMenu}
                  type="vertical"
                />
              </div>
            );
          })}
        </Card>
      </Container>
    </>
  );
};
